import { memo } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { QuestionSectionWrapper } from "../../../../../_shared/ui/components/system/question/_layouts/item-wrapper";

type Props = {
	maxStockNum: ForNodeType<InputMaybe<number> | undefined> | undefined;
	onSetMaxStockNum: (input: number | undefined) => void;

	isEdited: boolean;
	hasError: boolean;

	title?: string;
	guide?: string;
};

/**
 * 通算在庫
 */
export const QuestionOptionMaxStockNum = memo(
	({ maxStockNum, onSetMaxStockNum, isEdited, hasError, title: _title, guide: _guide }: Props) => {
		const title = _title ?? "通算合計在庫数の上限";
		const guide = _guide ?? "";

		return (
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title={title}
				guide={guide}
				isEdited={isEdited}
				hasError={hasError}
				inputChildren={
					<div className="flex flex-col gap-y-6">
						<QuestionSectionWrapper>
							<p>通算</p>

							<InputNumberField
								value={maxStockNum?.value ?? undefined}
								handleInput={onSetMaxStockNum}
								errorMessage={maxStockNum?.error}
								hiddenSpinButton={false}
							/>
							<p>個まで提供可能</p>
						</QuestionSectionWrapper>
						<div className="text-sm text-error-600">
							<p>
								限定のグッズなど、<strong>通算での在庫に限りがある場合</strong> にご利用ください。
							</p>
							<p>通算での在庫に限りがない場合は設定の必要はありせん。</p>
						</div>
					</div>
				}
			/>
		);
	},
);

QuestionOptionMaxStockNum.displayName = "QuestionOptionMaxStockNum";
